import { DocReviewSection } from '../../docReviewSection';
import { EntityReviewTable } from './entityReviewTable';

export interface EntityDetailsSectionProps {
  data: Record<string, any>;
}

const DETAIL_FIELDS = ['borrowerEntityName', 'borrowerEntityAddress'];

export const EntityDetailsSection = ({ data }: EntityDetailsSectionProps) => {
  const items = (data?.items ?? []).filter(item => DETAIL_FIELDS.includes(item.itemName));
  if (!items.length) {
    return null;
  }
  return (
    <DocReviewSection>
      <EntityReviewTable data={{ ...data, items }} />
    </DocReviewSection>
  );
};

export default EntityDetailsSection;
